import React from 'react'
import styled from 'styled-components'
import Typography, { TypographyProps } from '@material-ui/core/Typography'
import { grey } from '@material-ui/core/colors'

interface ICaptionTextProp {
  children: string
}

const StyledCaptionLight = styled(Typography)`
  color: ${grey[500]};
` as React.ComponentType<TypographyProps>

export const CaptionLight = ({
  children,
  ...props
}: TypographyProps & ICaptionTextProp) => (
  <StyledCaptionLight variant="caption" {...props}>
    {children}
  </StyledCaptionLight>
)
